import React from 'react';
import './AboutSection.css';

const AboutSection = () => {
  return (
    <section id="about" className="section about-section">
      <div className="section-inner">
        <h2>About CampusXL</h2>
        <p>
          CampusXL is an education solutions company partnering with universities to design and deliver industry-aligned academic programs across high-demand domains such as Engineering & Computer Science, Management, Pharmacy, Allied Health Sciences, and Liberal Arts & Humanities.
          With a strong focus on Engineering & Computer Science and Management as our core pillars, we aim to build future-ready talent by integrating cutting-edge curriculum, industry exposure, and career-driven learning pathways.
        </p>
        <br />
        <p>
          Our approach goes beyond traditional education—we enable institutions to create holistic academic ecosystems by supporting student admissions, program delivery, industry integration, internships, and final placements.
          By seamlessly connecting academia, industry, and innovation, CampusXL empowers students with practical skills, global perspectives, and career opportunities—ensuring they are not just job-ready, but future-ready.
        </p>
        <div className="about-grid">
          <div className="about-card">
            <h3>College discovery</h3>
            <p>
              Explore colleges by course, location and fees with clear,
              comparable information.
            </p>
          </div>
          <div className="about-card">
            <h3>Application support</h3>
            <p>
              Stay on top of important forms, dates and documents with simple
              checklists.
            </p>
          </div>
          <div className="about-card">
            <h3>Counsellor guidance</h3>
            <p>
              Talk to experienced counsellors who understand both students and
              parents.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;

